import React, { Component } from 'react'

 class assignedItems extends Component {
    render() {
        return (
            <div>
                <h1>assignedItems</h1>
            </div>
        )
    }
}

export default assignedItems;


// WEBPACK FOOTER //
// ./src/components/Delivery-Report/assigned-items.js